(() => {
  if (window.etCartRecommendationsInitialized) return;
  window.etCartRecommendationsInitialized = true;
  const init = root => {
    root.querySelectorAll('[data-et-recommendation]').forEach(card => {
      if (card.dataset.etReady) return;
      card.dataset.etReady = 'true';
      const media = card.querySelector('[data-et-media]');
      const images = [...card.querySelectorAll('.et-recommendation__image')];
      if (!images.length) return;
      let index = 0;
      const show = n => {
        index = (n + images.length) % images.length;
        images.forEach((img,i) => img.classList.toggle('is-active',i===index));
      };
      show(0);
      media.querySelector('[data-et-prev]')?.addEventListener('click', e => {e.preventDefault();e.stopPropagation();show(index-1);});
      media.querySelector('[data-et-next]')?.addEventListener('click', e => {e.preventDefault();e.stopPropagation();show(index+1);});
      if (matchMedia('(hover:hover)').matches && images.length>1) {
        media.addEventListener('mouseenter',()=>{if(index===0)show(1);});
        media.addEventListener('mouseleave',()=>show(0));
      }
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('#cart-drawer [data-et-qty-minus], #cart-drawer [data-et-qty-plus]');
    if (!button) return;
    const wrapper = button.closest('line-item-quantity');
    const input = wrapper?.querySelector('input[data-line-key]');
    if (!input) return;
    const current = Number(input.value) || 0;
    const next = current + (button.hasAttribute('data-et-qty-plus') ? 1 : -1);
    const max = input.max ? Number(input.max) : Infinity;
    if (next < 0 || next > max || button.disabled) return;
    input.value = String(next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  init(document);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if(node.nodeType===1) init(node);
    }
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
